<template>
    <div class="configurator-slider-controls">
        <button type="button" :class="['icon-arrow3--left', 'slider-button', {'hidden': !showLeftArrow}, {'has-background': showArrowBackground}]" @click="onClickArrowLeft()">
            <span class="sr-only">Move to left</span>
        </button>
        <button type="button" :class="['icon-arrow3--right', 'slider-button', {'hidden': !showRightArrow}, {'has-background': showArrowBackground}]" @click="onClickArrowRight()">
            <span class="sr-only">Move to right</span>
        </button>
    </div>
</template>

<script src="./slider-controls.js"></script>
